import React from 'react'

const PremiumBanner = () => {
  return (
    <div className="w-full bg-gradient-to-r from-primaryAccent-9 to-primaryAccent-7 dark:from-primaryAccent-11 dark:to-primaryAccent-9 px-4 py-2 shadow-sm border-b border-primaryAccent-6 dark:border-primaryAccent-8">
        <p className="max-w-[350px] sm:max-w-full text-sm font-medium text-white dark:text-primaryAccent-1 text-left sm:text-center flex items-center justify-center gap-2">
            <span className="hidden sm:inline">✨</span>
            Publishing requires a Premium X (formerly Twitter) account
            <span className="hidden sm:inline">✨</span>
        </p>
    </div>
  );
};

export default PremiumBanner
